import { Menu as MenuCore } from '@studiometa/ui';

/**
 *  component
 */
export default class Menu extends MenuCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Menu',
    ...MenuCore.config,
    emits: ['toggling'],
  };

  /**
   * toggle the menu.
   */
  toggle() {
    this.$emit('toggling', this.$el);
    this.menuList.toggle();
  }
}
